import React, { useState } from 'react';
import { Button, Grid, IconButton, InputAdornment, TextField, Typography } from '@material-ui/core';
import EntitySelector from './entity_selector/EntitySelector';
import { searchMainAuthor } from '../../services/main_author';
import DeleteIcon from '@material-ui/icons/Delete';

const MainAuthorEditor = ({ author, userStore, setAuthor, onRemove }) => {
  const [editing, setEditing] = useState(false);

  const getLabel = (author) => {
    if (author === null) {
      return '';
    }

    if (author.name === null) {
      return '';
    }

    if (author.id === null) {
      return `NOVO - ${author.name}`;
    }

    return `ID ${author.id} - ${author.name}`;
  };

  if (!editing) {
    return (
      <div>
        <TextField
          sx={{ width: 210 }} label='Autor' type='text' color='success'
          focused size='small' disabled InputLabelProps={{ shrink: true }}
          value={getLabel(author)}
          InputProps={{
            endAdornment: <InputAdornment position='end'>
              <IconButton
                edge='end'
                onClick={() => onRemove()}>
                <DeleteIcon />
              </IconButton>
            </InputAdornment>
          }}
        />
        <Button size='large' type='button'
                onClick={() => setEditing(true)}>
          Editar
        </Button>
      </div>
    );
  }

  return (
    <EntitySelector
      label={getLabel(author)}
      popupPlacement='bottom-start'
      onChange={async (inputValue) => searchMainAuthor(inputValue, userStore)}
      onSaveEmpty={(value) => {
        setAuthor({id: null, name: value});
        setEditing(false);
      }}
      onSave={async (author) => {
        setAuthor({id: author.id, name: author.name});
        setEditing(false);
      }}
      onSaveSuccess={(item) => {
      }}
      onCancel={() => setEditing(false)}
      renderSelectedLabel={(item) => getLabel(item)}
      renderOption={(author) => {
        return (
          <Typography sx={{ textAlign: 'left' }} key={author.id}>
            <b>{author.name}</b>
            <br />ID {author.id}
          </Typography>
        );
      }}
    />
  );
};

export default MainAuthorEditor;
